import React, { useState } from "react";
import ReactPaginate from "react-paginate";
import RankedTable from "../layout/RankedTable";
import AppButton from "../layout/AppButton";
import { formatDateTime } from "../../utils/dateFormat";

const PAGE_SIZE = 15;

const PersonaManagementTable = ({
  searchText,
  setSearchText,
  filteredPersonas,
  onDeletePersona,
  onEditPersona,
  onAddReport,
}) => {
  const [currentPage, setCurrentPage] = useState(0);

  const pageCount = Math.ceil(filteredPersonas.length / PAGE_SIZE);
  const currentData = filteredPersonas.slice(currentPage * PAGE_SIZE, (currentPage + 1) * PAGE_SIZE);

  const handleSearch = (e) => { setSearchText(e.target.value); setCurrentPage(0); };

  return (
    <div className="pb-2">
      <div className="flex items-center justify-between mb-3 flex-wrap gap-3 px-1">
        <div className="flex items-center gap-3">
          <input
            type="text"
            className="text-sm border border-gray-200 rounded-lg px-3 py-2 bg-white text-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-100"
            style={{ minWidth: "280px" }}
            placeholder="Search by persona name"
            value={searchText}
            onChange={handleSearch}
          />
       
        </div>
        {pageCount > 1 && (
          <ReactPaginate
            previousLabel={"‹"} nextLabel={"›"} breakLabel={"..."}
            pageCount={pageCount} marginPagesDisplayed={1} pageRangeDisplayed={3}
            onPageChange={({ selected }) => setCurrentPage(selected)}
            forcePage={currentPage}
            containerClassName={"pagination"} pageClassName={"page-item"} pageLinkClassName={"page-link"}
            previousClassName={"page-item"} previousLinkClassName={"page-link"}
            nextClassName={"page-item"} nextLinkClassName={"page-link"}
            breakClassName={"page-item"} breakLinkClassName={"page-link"} activeClassName={"active"}
          />
        )}
      </div>

      <RankedTable
        columns={[
          { label: "Persona Name" },
          { label: "Created At", width: "20%" },
          { label: "Actions", width: "30%", align: "left" },
        ]}
        rows={currentData}
        emptyText="No matching personas found."
        renderRow={(persona) => (<>
          <td className="px-5 py-3">
            <div className="flex flex-col gap-0.5">
              <span style={{ fontSize: "14px", textTransform: "capitalize", fontWeight: 700, color: "#1f2937" }}>{persona.name}</span>
              {persona.createdBy && <span className="text-[12px] text-gray-400 font-medium">{persona.createdBy}</span>}
            </div>
          </td>
          <td className="px-5 py-3">
            <div className="flex flex-col gap-0.5">
              <span className="text-gray-500 text-xs">{formatDateTime(persona.createdAt).date}</span>
              <span className="text-gray-400 text-[11px]">{formatDateTime(persona.createdAt).time}</span>
            </div>
          </td>
          <td className="px-5 py-3">
            <div className="flex items-center justify-start gap-2 flex-wrap">
              <AppButton
                variant="fill"
                fillColor="#14653a"
                onClick={() => onAddReport(persona)}
                style={{ padding: "4px 10px", fontSize: "11px" }}
              >
                Add Report
              </AppButton>
              <AppButton
                variant="fill"
                onClick={() => onEditPersona(persona)}
                style={{ padding: "4px 10px", fontSize: "11px" }}
              >
                Edit
              </AppButton>
              <AppButton
                variant="outline"
                onClick={() => onDeletePersona(persona.id)}
                style={{ padding: "4px 10px", fontSize: "11px" }}
              >
                Delete
              </AppButton>
            </div>
          </td>
        </>)}
      />
    </div>
  );
};

export default PersonaManagementTable;
